import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from '@mui/material';
import { ReactElement } from 'react';
import { useTranslate } from 'ra-core';

interface SaveQueryDialogProps {
  open: boolean;
  queryName: string;
  onClose: () => void;
  onQueryNameChange: (value: string) => void;
  onSave: () => void;
}

function SaveQueryDialog(props: SaveQueryDialogProps): ReactElement {
  const { open, queryName, onClose, onQueryNameChange, onSave } = props;
  const translate = useTranslate();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{translate('ra.saved_queries.new_label', { _: 'Save current query' })}</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 1 }}>
          {translate('ra.saved_queries.new_dialog_text', {
            _: 'Save the current filter configuration to reuse it later.'
          })}
        </DialogContentText>
        <TextField
          autoFocus
          fullWidth
          size="small"
          placeholder={translate('ra.saved_queries.label', { _: 'Query name' })}
          value={queryName}
          onChange={(event) => onQueryNameChange(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              onSave();
            }
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} size="small">
          {translate('ra.action.cancel', { _: 'Cancel' })}
        </Button>
        <Button onClick={onSave} size="small" disabled={!queryName.trim()}>
          {translate('ra.action.save', { _: 'Save' })}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export { SaveQueryDialog };
